import { Badge, Chip } from "@mui/material";
import { FrameworkControlStatus } from "../../frameworks/Frameworks.types";
import { exhaustiveGuard } from "../../../common/utilities";

export interface IFrameworkStatusChipProps {
    value: string;
    status: FrameworkControlStatus;
    isExcluded: boolean;
}

function FrameworkStatusChip(props: IFrameworkStatusChipProps) {
    function getColor(): [bgColor: string, color: string, dotColor: string] {
        if (props.isExcluded) {
            return ["#EAE4E4", "#585858", "#585858"];
        }

        switch (props.status) {
            case FrameworkControlStatus.Completed:
                return ["#E6FAED", "#36847D", "#2BD5C4"];
            case FrameworkControlStatus.Ongoing:
                return ["#ECFBFD", "#1A8092", "#11CCE5"];
            case FrameworkControlStatus.ApprovedInternally:
                return ["#E6FAED", "#36847D", "#2BD5C4"];
            case FrameworkControlStatus.Planned:
                return ["#E1E7FD", "#2C2A90", "#353494"];
            case FrameworkControlStatus.ReadyForApproval:
                return ["#FFD5F4CB", "#F800BE", "#F700BE"];
            case FrameworkControlStatus.Overdue:
                return ["#FEE4E2", "#FF3F78", "#FF3F78"];
            default:
                exhaustiveGuard(props.status);
        }
    }

    const [bgColor, color, dotColor] = getColor();

    return (
        <Chip
            sx={{
                padding: 1,
                color: color,
                backgroundColor: bgColor,
                "& .MuiBadge-root.MuiChip-icon": {
                    marginRight: "1px",
                },
                "& .MuiBadge-badge": {
                    backgroundColor: dotColor,
                },
            }}
            size={"small"}
            icon={<Badge variant={"dot"} color="primary" />}
            label={props.value}
        />
    );
}

export default FrameworkStatusChip;
